;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useEffect, useState } from 'react';

export function useAnimation(duration) {
    const [progress, setProgress] = useState(0);
    const [startTime, setStartTime] = useState(Date.now());
    const play = () => setStartTime(Date.now());
    useEffect(() => {
        let queuedFrame;
        const frame = () => {
            const now = Date.now() - startTime;
            if (now < duration) queuedFrame = requestAnimationFrame(frame);
            setProgress(Math.min(1, now / duration));
        };
        frame();
        return () => cancelAnimationFrame(queuedFrame);
    }, [startTime, duration]);
    return [progress, play];
}
